/**
 * Estados vigentes para UI de Admin (solo frontend).
 * NO se cambian nombres en BD ni se migran datos.
 * Si un doc tiene un estado que no está aquí, se muestra como "Estado actual: X (legacy)" y no se ofrece en el select.
 */

/** Estados de solicitudes_empresa que sí se usan actualmente en el sistema (select solo muestra estos). */
export const SOLICITUDES_EMPRESA_STATUS_ACTIVE = [
  'ingresada',
  'asignada',
  'pendiente',
  'en_revision',
  'correo_enviado',
  'pendiente_validacion',
  'en_visita',
  'validada',
  'activa',
  'activada',
  'aprobada',
  'credenciales_asignadas',
  'rechazada'
];

/** Etiquetas amigables para estados de solicitudes_empresa. */
export const SOLICITUDES_EMPRESA_STATUS_LABELS = {
  ingresada: 'Ingresada',
  asignada: 'Asignada',
  pendiente: 'Pendiente',
  en_revision: 'En Revisión',
  correo_enviado: 'Correo Enviado',
  pendiente_validacion: 'Pendiente de Validación',
  en_visita: 'En Visita',
  validada: 'Validada',
  activa: 'Activa',
  activada: 'Activada (Visible en Home)',
  aprobada: 'Aprobada',
  credenciales_asignadas: 'Credenciales Asignadas',
  rechazada: 'Rechazada'
};

/** Colores para badges por estado (solicitudes_empresa). */
export const SOLICITUDES_EMPRESA_STATUS_COLORS = {
  ingresada: 'yellow',
  asignada: 'blue',
  pendiente: 'yellow',
  en_revision: 'blue',
  correo_enviado: 'purple',
  pendiente_validacion: 'orange',
  en_visita: 'amber',
  validada: 'cyan',
  activa: 'green',
  activada: 'green',
  aprobada: 'green',
  credenciales_asignadas: 'purple',
  rechazada: 'red'
};

/** Opción "Todos" para filtros (value vacío). */
export const FILTER_ALL_VALUE = '';
